import TencentCloudChat from "@tencentcloud/chat";

export const MSG_TYPES = {
    text: TencentCloudChat.TYPES.MSG_TEXT,
    image: TencentCloudChat.TYPES.MSG_IMAGE,
    audio: TencentCloudChat.TYPES.MSG_AUDIO,
    video: TencentCloudChat.TYPES.MSG_VIDEO,
    custom: TencentCloudChat.TYPES.MSG_CUSTOM,
    face: TencentCloudChat.TYPES.MSG_FACE,
    file: TencentCloudChat.TYPES.MSG_FILE,
};

export enum SYSTEM_MSG_FIELD_CONTENT {
    UserJoined = "UserJoined",
    UserExit = "UserExit",
    ChannelRename = "ChannelRename",
}
